import * as type from '../actions/types';
import {
  mergeFetchedGuestProfile,
  mergeObeeUpdateIntoGuestProfileData,
} from '../services/obeeGuestProfileMerge';
import { safeParse } from '../utils/helpers';

/** GraphQL may return AWSJSON as string or parsed object — keep logic local to this slice. */
const parseGuestProfileData = (raw) => {
  if (raw == null) return {};
  if (typeof raw === 'object') return raw;
  return safeParse(raw, {});
};

const initialState = {
  data: {},
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_CRM_GUEST_PROFILE_PENDING: {
      return {
        ...state,
        pending: true,
        error: '',
        // Keep existing profile data while refetching — clearing data caused UI to fall back to stale table row.
      };
    }

    case type.FETCH_CRM_GUEST_PROFILE_SUCCESS: {
      const incoming = parseGuestProfileData(action.payload?.data);
      return {
        ...state,
        data: mergeFetchedGuestProfile(state.data, incoming),
        pending: false,
        success: true,
      };
    }

    case type.FETCH_CRM_GUEST_PROFILE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };

    case type.UPDATE_OBEE_GUEST_SUCCESS: {
      return {
        ...state,
        data: mergeObeeUpdateIntoGuestProfileData(state.data, action.payload),
      };
    }

    default:
      return state;
  }
};
